class Header extends HTMLElement {
	constructor() {
		super();
		this.announcement = document.querySelector(".fav-announcement-bar");
		this.scrollCheckEnabled =
			this.dataset.transparentDisabledScroll == "true";
		this.setupTransparentHeader();
	}

	fill() {
		this.classList.add("animation-inprogress");
		setTimeout(() => {
			this.classList.remove("animation-inprogress");
		}, 400);
		this.classList.add("is-filled");
		// this.announcement.classList.add("is-filled");
	}

	unfill() {
		if (!document.querySelector("body").classList.contains("search-open")) {
			this.classList.add("animation-inprogress");
			setTimeout(() => {
				this.classList.remove("animation-inprogress");
			}, 400);
			this.classList.remove("is-filled");
			// this.announcement.classList.remove("is-filled");
		}
	}

	checkTransparency(e) {
		const offsetBeforeChanging = 250;
		if (
			(this.scrollCheckEnabled &&
				window.scrollY >= offsetBeforeChanging) ||
			(e && e.type == "mouseover")
		) {
			if (!this.classList.contains("is-filled")) {
				this.fill();
			}
		} else {
			if (this.classList.contains("is-filled") && !this.classList.contains("menu-open")) {
				this.unfill();
			}
		}
		return;
	}

	setupTransparentHeader() {
		if (
			document.querySelector(
				".shopify-section:first-child [allow-transparent-header]"
			) &&
			!this.getAttribute("transparent_disbaled")
		) {
			this.setAttribute("allow-transparency", "");
			// this.announcement.setAttribute("allow-transparency", "");
			if (this.scrollCheckEnabled) {
				window.addEventListener(
					"scroll",
					this.checkTransparency.bind(this)
				);
			}
			// if (window.screen.width > 768) {
			this.addEventListener(
				"mouseover",
				this.checkTransparency.bind(this)
			);
			this.addEventListener(
				"mouseleave",
				this.checkTransparency.bind(this)
			);
			// }
			this.checkTransparency();
		} else {
			this.removeAttribute("allow-transparency");
		}
	}
}

customElements.define("header-fav", Header);

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);
			this.loadSectionData();
		};
		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: "0px 0px 2000px 0px",
		}).observe(this);
	}

	loadSectionData() {
		fetch(this.dataset.url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement("div");
				html.innerHTML = text;
				const recommendations = html.querySelector(
					"product-recommendations"
				);

				if (
					recommendations &&
					recommendations.innerHTML.trim().length
				) {
					this.innerHTML = recommendations.innerHTML;
				}

				if (html.querySelector(".grid__item")) {
					this.classList.add("product-recommendations--loaded");
				}
			})
			.catch((e) => {
				console.error(e);
			});
	}
}

customElements.define("product-recommendations", ProductRecommendations);

class RecommendedProducts extends HTMLElement {
	constructor() {
		super();
		this.maxRecommended =
		this.dataset.maxReco || this.dataset.desktopSlide * 2 || 10;
		if (this.dataset.swiper) {
			this.loadSlider();
		}
	}
	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);
			this.init();
		};
		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: "0px 0px 400px 0px",
		}).observe(this);
	}

	async init() {
		const productsIds = this.getProductsIds();
		if (productsIds && productsIds.length > 0) {
			const responses = await this.getResults(productsIds);
			if (responses.length > 0) {
				const limit = Math.round(
					this.maxRecommended / productsIds.length
				);
				this.parentElement
					.querySelector(".swiper-wrapper.fallback-collection")
					?.remove();
				this.closest(".cart-drawer-recommendations")
					?.querySelector(".recommendation_heading")
					?.classList.remove("hidden");
				for (let i = 0; i < limit; i++) {
					responses.forEach((response) => {
						var inserted = false;
						while (!inserted) {
							const element = response[i];
							if (element) {
								const prodId = parseInt(
									element?.querySelector("[data-product-id]")
										?.dataset.productId
								);
								if (prodId && !productsIds.includes(prodId)) {
									this.appendChild(element.cloneNode(true));
									productsIds.push(prodId);
									inserted = true;
								} else { 
									response[i].parentNode.removeChild(
										response[i]
									);
								}
							} else {
								inserted = true;
							}
						}
					});
				}
			}
		} else {
			this.remove();
		}
		if (this.dataset.swiper) {
			this.loadSlider();
		}
	}

	getProductsIds() {
		const productData = JSON.parse(
			localStorage.getItem("recentlyViewedProduct")
		);
		if (productData) {
			const products = productData.reverse().slice(0, 5);
			const productsIds = products.map((product) => parseInt(product.id));
			return productsIds;
		}
		return false;
	}

	async getResults(ids) {
		const responses = [];
		for (let id of ids) {
			var url = this.dataset.url.replace("[product_id]", id);
			const response = await this.getRecommendations(url);
			responses.push(response);
		}
		return responses;
	}

	getRecommendations(url) {
		return fetch(url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement("div");
				html.innerHTML = text;
				const recommendations = html.querySelector(this.tagName);

				if (
					recommendations &&
					recommendations.innerHTML.trim().length
				) {
					return recommendations.children;
				}
			})
			.catch((e) => {
				console.error(e);
			});
	}

	loadSlider() {
		if (typeof Swiper === 'function') {
			this.dispatchEventSlider();
		} else {
			const _self = this;
			document.addEventListener("swiper-loaded", function(event) {
				_self.dispatchEventSlider();
			});
		}
	}

	dispatchEventSlider() {
		let event = new Event(
			`recommendations-loaded-${this.dataset.section}`,
			{ bubbles: true }
		);
		document.body.dispatchEvent(event);
	}
}

customElements.define("recommended-products", RecommendedProducts);

class RecommendedProductsJson extends RecommendedProducts {
	constructor() {
		super();
	}

	getProductsIds() {
		return JSON.parse(
			this.querySelector('[type="application/json"]').textContent
		);
	}
}

customElements.define("recommended-products-json", RecommendedProductsJson);

const pinchZoom = (imageElement) => {
	let imageElementScale = 1;

	let start = {};

	// Calculate distance between two fingers
	const distance = (event) => {
		return Math.hypot(
			event.touches[0].pageX - event.touches[1].pageX,
			event.touches[0].pageY - event.touches[1].pageY
		);
	};

	imageElement.addEventListener("touchstart", (event) => {
		if (event.touches.length === 2) {
			event.preventDefault(); // Prevent page scroll

			// Calculate where the fingers have started on the X and Y axis
			start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
			start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
			start.distance = distance(event);
		}
	});

	imageElement.addEventListener("touchmove", (event) => {
		console.log("touchmove", event);
		if (event.touches.length === 2) {
			event.preventDefault(); // Prevent page scroll
			let scale;

			// Safari provides event.scale as two fingers move on the screen
			// For other browsers just calculate the scale manually
			if (event.scale) {
				scale = event.scale;
			} else {
				const deltaDistance = distance(event);
				scale = deltaDistance / start.distance;
			}

			imageElementScale = Math.min(Math.max(1, scale), 4);

			// Calculate how much the fingers have moved on the X and Y axis
			const deltaX =
				((event.touches[0].pageX + event.touches[1].pageX) / 2 -
					start.x) *
				2; // x2 for accelarated movement
			const deltaY =
				((event.touches[0].pageY + event.touches[1].pageY) / 2 -
					start.y) *
				2; // x2 for accelarated movement

			// Transform the image to make it grow and move with fingers
			const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
			imageElement.style.transform = transform;
			imageElement.style.WebkitTransform = transform;
			imageElement.style.zIndex = "9999";
		}
	});

	imageElement.addEventListener("touchend", (event) => {
		// Reset image to it's original format
		imageElement.style.transform = "";
		imageElement.style.WebkitTransform = "";
		imageElement.style.zIndex = "";
	});
};

class ProductGallery extends HTMLElement {
	constructor() {
		super();
		this.sections = {};
		this.querySelectorAll(".swiper-slide").forEach((slide) => {
			this.sections[slide.dataset.media] = {
				offset: slide.offsetTop,
				media: slide.dataset.media,
			};
		});
		this.scrollHandler();
		window.addEventListener('scroll', this.scrollHandler.bind(this));
	}
	
	scrollHandler() {
		var i = 0;
		var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
		for (i in this.sections) {
			if (this.sections[i].offset <= scrollPosition) {
				this.querySelector('.dot.is-active')?.classList.remove('is-active');
				this.querySelector(`.dot[data-media='${this.sections[i].media}']`)?.classList.add('is-active');
			}
		}

	}
}

customElements.define("product-gallery", ProductGallery);

class CardSwatches extends HTMLElement {
	constructor() {
		super();
		this.collection = document.querySelector('collection-fav');
	}

	swatchTemplate = (brandName, colorName, url, background) => `
		<a class='card_image_toggle color' aria-label="${brandName} ${colorName}" href='/products/${url}'>
			<span
				class='color_swatch'
				style="background: ${background}"
			>
			</span>
		</a>`;

	displaySwatchesUnsubscriber = undefined;
	
	connectedCallback() {
		this.displaySwatchesUnsubscriber = subscribe(PUB_SUB_EVENTS.collectionFetched, this.displaySwatches.bind(this));
	}

	disconnectedCallback() {
		if (this.displaySwatchesUnsubscriber) {
			this.displaySwatchesUnsubscriber();
		}
	}

	displaySwatches() {
		this.collection.data.forEach(product => {

			var data = product.node.metafields.map( (x) => x && x.value );
			
			if (this.dataset.brandName == data[0]) {
				const background = data[3] ? `url(${data[3]}&transform=resize=50x50)` : data[2];
				this.innerHTML += this.swatchTemplate(data[0], data[1], product.node.handle, background);
			}
		});
	}
}

customElements.define("card-swatches", CardSwatches);
